/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingConfig } from '../../config/loading.config';
import { bodyTitleConfig } from '../../config/body-title.config';
import { emailFieldConfig } from '../../config/email-field.config';
import { footerConfig } from '../../config/footer.config';
import { headerConfig } from '../../config/header.config';
import insuranceCalcConfig from '../../config/insurance-calculator.config.json';
import { kycFormConfig } from '../../config/kyc-form.config';
import { notificationConfig } from '../../config/notification.config';
import { policyOptionConfig } from '../../config/policy-option.config';
import { dobForm } from '../../config/dob.field.config';
import rightBlockConfig from '../../config/right-faq-block.config.json';

export interface IStaticContentPluginMethods extends IPluginMethodMap {
  getStaticContentSync(args?: any): any;
}

export class StaticContentPlugin implements IAgentPlugin {
  readonly methods: IStaticContentPluginMethods;

  constructor() {
    this.methods = {
      getStaticContentSync: this.getStaticContentSync.bind(this),
    };
  }

  getStaticContentSync(args?: any) {
    return {
      ...headerConfig,
      ...footerConfig,
      loading: loadingConfig,
      bodyTitle: bodyTitleConfig,
      rightBlockContent: rightBlockConfig,
      policyOptions: policyOptionConfig?.options,
      kycFormConfig: kycFormConfig,
      dobConfig: dobForm,
      emailKyc: emailFieldConfig,
      policyStatus: policyOptionConfig,
      notification: notificationConfig,
    };
  }
}
